export default __webpack_public_path__ + "static/media/disable-icon.e4ba4f06.svg";